import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRefreshCw, FiType, FiEdit3, FiImage } = FiIcons;

function Header({ onReset, currentStep, onStepChange }) {
  const getStepIndicator = () => {
    const steps = [
      { key: 'input', label: 'Quote', icon: FiType },
      { key: 'customize', label: 'Customize', icon: FiEdit3 },
      { key: 'preview', label: 'Preview', icon: FiImage }
    ];

    const currentIndex = steps.findIndex(step => step.key === currentStep || (currentStep === 'preview' && step.key === 'preview'));

    return (
      <div className="flex items-center space-x-2">
        {steps.map((step, index) => (
          <div key={step.key} className="flex items-center">
            <button
              onClick={() => onStepChange && onStepChange(step.key)}
              className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-300 ${
                index <= currentIndex 
                  ? 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200 cursor-pointer' 
                  : 'bg-gray-100 text-gray-400 hover:bg-gray-200 cursor-pointer'
              }`}
            >
              <SafeIcon icon={step.icon} className="w-4 h-4" />
              <span className="hidden sm:inline">{step.label}</span>
            </button>
            {index < steps.length - 1 && (
              <div className={`w-8 h-px mx-2 transition-colors duration-300 ${index < currentIndex ? 'bg-indigo-300' : 'bg-gray-200'}`} />
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <motion.header 
      initial={{ y: -20, opacity: 0 }} 
      animate={{ y: 0, opacity: 1 }} 
      className="bg-white shadow-sm border-b border-gray-200 sticky top-[56px] z-30"
    >
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center"></div>
        <div className="hidden md:block">
          {getStepIndicator()}
        </div>
        <button
          onClick={onReset}
          className="flex items-center space-x-2 px-4 py-2 bg-gray-50 hover:bg-gray-100 text-gray-700 rounded-lg transition-all border border-gray-200 hover:border-gray-300 shadow-sm"
        >
          <SafeIcon icon={FiRefreshCw} className="w-4 h-4" />
          <span className="hidden sm:inline font-medium">New Quote</span>
        </button>
      </div>
      <div className="md:hidden px-4 pb-4 overflow-x-auto">
        <div className="min-w-max">
          {getStepIndicator()}
        </div>
      </div>
    </motion.header>
  );
}

export default Header;